import { useState, useEffect, useContext, useRef } from "react";
import AppContext from "../../context";
import css from "./Master.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import Popup from "../../components/Popup/Popup";
import { FaEdit } from "react-icons/fa";
import { UserService } from "../../services/user";
import { AddUserEntity, UserEntity } from "../../entities/UserEntity";
import { PopUpPilihEntity } from "../../components/Popup/PopupPilihEntity";
import PopupPilih from "../../components/Popup/PopupPilih";
import ExcelUtils from "../../utils/excel";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { VendorService } from "../../services/vendors";
import { format } from "date-fns";
import { RiLockPasswordFill } from "react-icons/ri";
import change from "../../layouts/ChangePass/ChangePass.module.css";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { IoCloseCircleSharp } from "react-icons/io5";

export default function MasterUser() {
    // ========================================= GLOBAL CONTEXT =========================================  //
    const context = useContext(AppContext);
    const contextAccessToken = context.contextAccessToken;
    const contextShowAlertFunc = context.contextShowAlertFunc;
    const contextShowLoadingFunc = context.contextShowLoadingFunc;
    const stateShowLoading = context.stateShowLoading
    // ========================================= GLOBAL CONTEXT =========================================  //


    // ========================================= STATE VIEW =========================================  //
    const [tableData, setTableData] = useState<UserEntity[]>([]);

    const [selectedUser, setSelectedUser] = useState<UserEntity | null>(null);
    const [selectedAddUser, setSelectedAddUser] = useState<AddUserEntity | null>(null);

    const [showPopup, setShowPopup] = useState(false);
    const [showPopupChangePass, setShowPopupChangePass] = useState(false);
    const [showPopupPilih, setShowPopupPilih] = useState(false);
    const [popUpPilihEntity, setPopUpPilihEntity] = useState<PopUpPilihEntity>();

    const userRef = useRef<HTMLInputElement | null>(null);

    const [pwd, setPwd] = useState<string | null>("");
    const [validPwd, setValidPwd] = useState(false);
    const [showPwd, setShowPwd] = useState(false);
    const [showConfirmPwd, setShowConfirmPwd] = useState(false);
    const [validPwdCheckUppercase, setValidPwdCheckUppercase] = useState(false);
    const [validPwdCheckLowercase, setValidPwdCheckLowercase] = useState(false);
    const [validPwdCheckNumber, setValidPwdCheckNumber] = useState(false);
    const [validPwdCheckSpecial, setValidPwdCheckSpecial] = useState(false);
    const [validPwdCheckLength, setValidPwdCheckLength] = useState(false);

    const [match, setMatch] = useState<string | null>("");
    const [validMatch, setValidMatch] = useState(false);



    // ========================================= STATE VIEW =========================================  //

    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    const handleSelectGrup = async () => {
        contextShowLoadingFunc(true);
        setShowPopup(false)
        try {
            const resp = await UserService.GetAllGrup();
            setPopUpPilihEntity(new PopUpPilihEntity({
                popupTitle: 'Pilih Grup',
                tableContent: resp,
                onClick: (row) => {
                    selectedUser != null ?
                        setSelectedUser((prevState: UserEntity | null) => {
                            if (prevState == null) {
                                return null;
                            } else {
                                return new UserEntity({
                                    ...prevState,
                                    id_grup: row.id,
                                    rolename: row.grup
                                })
                            }
                        })
                        :
                        setSelectedAddUser((prevState: AddUserEntity | null) => {
                            return new AddUserEntity({
                                ...prevState,
                                id_grup: row.id,
                                rolename: row.grup
                            })
                        })
                        ; setShowPopup(true)
                },
                onClose: () => { setShowPopupPilih(false); setShowPopup(true) }
            }))
            setShowPopupPilih(true);
            contextShowLoadingFunc(false);
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleSelectVendor = async () => {
        contextShowLoadingFunc(true);
        setShowPopup(false)
        try {
            const resp = await VendorService.GetAllVendor();
            setPopUpPilihEntity(new PopUpPilihEntity({
                popupTitle: 'Pilih Vendor',
                tableContent: resp,
                onClick: (row) => {
                    selectedUser != null ?
                        setSelectedUser((prevState: UserEntity | null) => {
                            if (prevState == null) {
                                return null;
                            } else {
                                return new UserEntity({
                                    ...prevState,
                                    id_vendor: row.id,
                                    vendor: row.nama
                                })
                            }
                        })
                        :
                        setSelectedAddUser((prevState: AddUserEntity | null) => {
                            return new AddUserEntity({
                                ...prevState,
                                id_vendor: row.id,
                                vendor: row.nama
                            })
                        })
                        ; setShowPopup(true)
                },
                onClose: () => { setShowPopupPilih(false); setShowPopup(true) }
            }))
            setShowPopupPilih(true);
            contextShowLoadingFunc(false);
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleAddNew = () => {
        setSelectedAddUser(null);
        setSelectedUser(null);
        setShowPopup(true);
    }

    const handlePopupDetail = (row: UserEntity) => {
        setSelectedUser(row);
        setShowPopup(true)
    }

    const handlePopupChangePassword = (row: UserEntity) => {
        setSelectedUser(row);
        setPwd(null)
        setMatch(null)
        setShowPopupChangePass(true)
    }

    const handleSaveAddAdmin = async () => {
        contextShowLoadingFunc(true);
        try {
            if (selectedAddUser == null ||
                selectedAddUser.id_grup == null ||
                selectedAddUser.username == null) {
                throw new Error("invalid user data")
            }
            const resp = await UserService.AddUser({ id_grup: selectedAddUser.id_grup, id_vendor: selectedAddUser.id_vendor, username: selectedAddUser.username });

            await generateData();
            contextShowLoadingFunc(false);
            setSelectedUser(null);
            setSelectedAddUser(null);
            setShowPopup(false);
            contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleSaveUpdateAdmin = async () => {
        contextShowLoadingFunc(true);
        try {
            if (selectedUser == null) { throw new Error("invalid selected user") }
            const resp = await UserService.UpdateUser(selectedUser, { id_grup: selectedUser.id_grup, id_vendor: selectedUser.id_vendor, username: selectedUser.username });
            await generateData();
            contextShowLoadingFunc(false);
            setSelectedUser(null);
            setShowPopup(false);
            contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    }

    const handleDeleteAdmin = async () => {
        return contextShowAlertFunc(new AlertEntity({
            message: `Apakah anda yakin ingin menghapus ${selectedUser?.username} ?`,
            onOk: async () => {
                contextShowLoadingFunc(true);
                try {
                    if (selectedUser == null) { throw new Error("invalid selected user") }
                    const resp = await UserService.DeleteUser(selectedUser);
                    await generateData();
                    contextShowLoadingFunc(false);
                    setSelectedUser(null);
                    setShowPopup(false);
                    contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
                } catch (error: any) {
                    contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
                    contextShowLoadingFunc(false);
                }
            },
            withCancel: true,
            withOk: true,
            level: 2
        }))
    }

    const handleGenerateExcel = async () => {
        if (tableData.length == 0) { return contextShowAlertFunc(new AlertEntity({ message: "NO DATA!", level: 3 })); }
        const column = ["username", "rolename", "vendor"];
        let values: { [key: string]: string }[] = [];
        for (let i = 0; i < tableData.length; i++) {
            values.push({
                username: tableData[i].username,
                rolename: tableData[i].rolename ?? '',
                vendor: tableData[i].vendor ?? '',
            })
        }
        ExcelUtils.export(`Admin List on ${format(new Date(), "yyyy-MM-dd")}`, column, values);
    }

    const generateData = async () => {
        contextShowLoadingFunc(true);
        try {
            const resp = await UserService.GetAllUser();
            setTableData(resp);
            contextShowLoadingFunc(false);
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    };

    async function updatePassword() {
        if (!selectedUser || pwd == null) { return }
        if (!validPwd) {
            return contextShowAlertFunc(new AlertEntity({ message: "New Password Must Valid", level: 3 }))
        }
        contextShowLoadingFunc(true);
        try {
            let resp = await UserService.ChangePassword(selectedUser, pwd);
            setPwd("");
            contextShowLoadingFunc(false);
            setShowPopupChangePass(false);
            return contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }))
        } catch (error: any) {
            contextShowLoadingFunc(false);
            return contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
        }
    }

    useEffect(() => {
        generateData();
    }, [contextAccessToken]);

    useEffect(() => {
        if (userRef != null && userRef.current != null) {
            userRef.current.focus();
        }
    }, []);

    useEffect(() => {
        if (pwd == null) return
        const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%*/]).{8,24}$/;
        const PWD_REGEX_UPPERCASE = /^(?=.*[A-Z])/;
        const PWD_REGEX_LOWERCASE = /^(?=.*[a-z])/;
        const PWD_REGEX_NUMBER = /^(?=.*[0-9])/;
        const PWD_REGEX_SPECIAL = /^(?=.*[!@#$%*/])/;
        const PWD_REGEX_LENGTH = /^.{8,24}/;

        setValidPwdCheckUppercase(PWD_REGEX_UPPERCASE.test(pwd));
        setValidPwdCheckLowercase(PWD_REGEX_LOWERCASE.test(pwd));
        setValidPwdCheckNumber(PWD_REGEX_NUMBER.test(pwd));
        setValidPwdCheckSpecial(PWD_REGEX_SPECIAL.test(pwd));
        setValidPwdCheckLength(PWD_REGEX_LENGTH.test(pwd));
        setValidPwd(PWD_REGEX.test(pwd));
        setValidMatch(pwd === match);
    }, [pwd, match]);


    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    return (
        <>
            <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
                <Card
                    detailTitle="Master User"
                    detailColor="var(--secondary-color)"
                    backgroundImage={backgroundCard}
                    stateShow={true}
                    detailCard={
                        <>
                            <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                                <div>
                                    <div style={{ color: "white", textAlign: "start" }}>Action :</div>
                                    <button className="cardButton" onClick={() => handleAddNew()} >
                                        Add New
                                    </button>
                                </div>
                                <div>
                                    <button className="cardButton" onClick={() => handleGenerateExcel()} >
                                        Generate Excel
                                    </button>
                                </div>
                            </div>
                            <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                            </div>
                        </>
                    }
                />
                <div
                    style={{ height: "65vh", overflow: "auto" }}>
                    <table className="tableclickcell">
                        {tableData.length > 0
                            ? <>
                                <thead>
                                    <tr>
                                        <th>no</th>
                                        <th>Nama</th>
                                        <th>Role</th>
                                        <th>Vendor</th>
                                        <th colSpan={2}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.map((row, idx) => {
                                        return <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{row.username}</td>
                                            <td>{row.rolename}</td>
                                            <td>{row.vendor}</td>
                                            <td className="group-pick" onClick={() => { handlePopupDetail(row) }}><FaEdit /> Edit</td>
                                            <td className="group-pick" style={{ padding: "0vh 0vw" }} onClick={() => { handlePopupChangePassword(row) }}><RiLockPasswordFill /> Change Pass.</td>
                                        </tr>
                                    })}
                                </tbody>
                            </>
                            : <thead><tr><th>no data available yet!</th></tr></thead>
                        }
                    </table>
                </div>

                {/* Popup Detail */}
                <Popup
                    setShowPopup={setShowPopup}
                    showPopup={showPopup}
                    popupTitle={selectedUser == null ? "Add New" : `Edit ${selectedUser?.username}`}
                    popupContent={
                        selectedUser == null
                            ? <>
                                <div className={css.form}>
                                    <div className={css.containerleftright}>
                                        <div className={css.leftposition}>
                                            <div className={css.label}> Username <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedAddUser?.username ?? ""}
                                                onChange={(event) => {
                                                    setSelectedAddUser((prevState: AddUserEntity | null) => {
                                                        return new AddUserEntity({
                                                            ...prevState,
                                                            username: event.target.value
                                                        })
                                                    });
                                                }}
                                            />
                                            <div className={css.label}> Role <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" readOnly
                                                value={selectedAddUser?.rolename ?? ""}
                                                onClick={handleSelectGrup}
                                            />
                                        </div>
                                        <div className={css.rightposition}>
                                            <div className={css.label}> Vendor {"(Jika Admin Jangan Diisi)"} <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" readOnly
                                                value={selectedAddUser?.vendor ?? ""}
                                                onClick={handleSelectVendor}
                                            />
                                        </div>
                                    </div>
                                    <div className={css.buttons2}>
                                        <div className={css.left}>
                                            <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                                                Close
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="primaryButton"
                                                onClick={() => { handleSaveAddAdmin() }} >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : <>
                                <div className={css.form}>
                                    <div className={css.containerleftright}>
                                        <div className={css.leftposition}>
                                            <div className={css.label}> Username <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" value={selectedUser?.username ?? ""}
                                                onChange={(event) => {
                                                    setSelectedUser((prevState: UserEntity | null) => {
                                                        if (prevState == null) {
                                                            return null;
                                                        } else {
                                                            return new UserEntity({
                                                                ...prevState,
                                                                username: event.target.value
                                                            })
                                                        }
                                                    });
                                                }}
                                            />
                                            <div className={css.label}> Role <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" readOnly
                                                value={selectedUser?.rolename ?? ""}
                                                onClick={handleSelectGrup}
                                            />
                                            <div className={css.label}> Vendor <span style={{ color: "red" }}>*</span></div>
                                            <input className={css.inputedit} type="text" readOnly
                                                value={selectedUser?.vendor ?? ""}
                                                onClick={handleSelectVendor}
                                            />
                                        </div>
                                    </div>
                                    <div className={css.buttons2}>
                                        <div className={css.left}>
                                            <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                                                Close
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="secondaryButton" onClick={() => handleDeleteAdmin()}>
                                                Delete
                                            </button>
                                        </div>
                                        <div className={css.right}>
                                            <button className="primaryButton"
                                                onClick={() => { handleSaveUpdateAdmin() }} >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                />

                {/* Popup Change Pass */}
                <Popup
                    setShowPopup={setShowPopupChangePass}
                    showPopup={showPopupChangePass}
                    popupTitle={`Change Password For "${selectedUser?.username}"`}
                    popupContent={
                        <>
                            <div className={change.containerMaster}>
                                <div className={change.background}>
                                    <div className={change.formPass}>
                                        <label>New Password</label>
                                        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                            <input
                                                ref={userRef}
                                                type={showPwd ? "text" : "password"}
                                                required
                                                onChange={(e) => setPwd(e.target.value)}
                                                value={pwd ?? ""}
                                                style={{ backgroundColor: "white", height: "100%" }}
                                            />
                                            <div style={{ color: "var(--header-color)", cursor: "pointer" }} onClick={() => { setShowPwd(!showPwd) }}>
                                                {showPwd ? <FaEye /> : <FaEyeSlash />}
                                            </div>
                                        </div>
                                        <label>Confirm New Password</label>
                                        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                            <input
                                                ref={userRef} type={showConfirmPwd ? "text" : "password"} style={{ flex: "98%", backgroundColor: "white" }}
                                                required onChange={(e) => setMatch(e.target.value)}
                                                value={match ?? ""}
                                            />
                                            <div style={{ color: "var(--header-color)", cursor: "pointer" }} onClick={() => { setShowConfirmPwd(!showConfirmPwd) }}>
                                                {showConfirmPwd ? <FaEye /> : <FaEyeSlash />}
                                            </div>
                                            <div style={{ flex: "2%" }}>
                                                {validMatch == true && match != "" ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                                            </div>
                                        </div>
                                        <div style={{ textAlign: "start", fontSize: "12px" }}>
                                            <div style={{ fontWeight: "600", fontSize: "14px" }}>New Password Must :</div>
                                            <div>
                                                {validPwdCheckUppercase == true ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                                                Use Uppercase
                                            </div>
                                            <div>
                                                {validPwdCheckLowercase == true ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                                                Use Lowercase
                                            </div>
                                            <div>
                                                {validPwdCheckNumber == true ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                                                Use Number
                                            </div>
                                            <div>
                                                {validPwdCheckSpecial == true ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                                                Use Special Character "!@#$%*/"
                                            </div>
                                            <div>
                                                {validPwdCheckLength == true ? <span style={{ color: "green", visibility: "visible" }}> <IoIosCheckmarkCircle /> </span> : <span style={{ color: "red", visibility: "visible" }}> <IoCloseCircleSharp /> </span>}
                                                More Than 8 Character
                                            </div>
                                        </div>

                                        <div className={change.buttons}>
                                            <button
                                                className="tertiaryButton"
                                                onClick={() => setShowPopupChangePass(false)}
                                            >
                                                Cancel
                                            </button>
                                            <button className="primaryButton" onClick={updatePassword}>
                                                Change
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                />

                {popUpPilihEntity != null
                    ? <PopupPilih
                        showPopup={showPopupPilih}
                        setShowPopup={setShowPopupPilih}
                        popUpPilihEntity={popUpPilihEntity}
                    />
                    : <></>}


            </div>
        </>
    );
}
